class AddFreeProduct {
  constructor() {
    this.variantId = window.freeProduct?.variantID;
    this.threshold = (window.freeProduct?.threshold || 0) * 100; // Convert to cents
    this.init();
  }

  async fetchCart() {
    const res = await fetch('/cart.js');
    return await res.json();
  }

  async addProduct() {
    try {
      await fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          items: [
            {
              id: this.variantId,
              quantity: 1,
              properties: {
                _free_gift: true,
                _variantId:this.variantId
              }
            }
          ]
        })
      });
      // Trigger UI/cart update
      if (typeof window.rerenderCart === 'function') window.rerenderCart();
    } catch (err) {
      console.error('Error adding free product:', err);
    }
  }

  async removeProduct(line) {
    try {
      await fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          line,
          quantity: 0
        })
      });
      // Trigger UI/cart update
      if (typeof window.rerenderCart === 'function') window.rerenderCart();
    } catch (err) {
      console.error('Error removing free product:', err);
    }
  }

  async freeGiftUpdate(cart) {
    if (!this.variantId || !this.threshold) return;

    const totalPrice = cart.total_price;
    const giftLineIndex = cart.items.findIndex(
      (item) =>
        item.variant_id === this.variantId &&
        item.properties &&
        item.properties['_free_gift']
    );

    const giftExists = giftLineIndex !== -1;

    // If gift already exists and threshold is met, do nothing
    if (giftExists && totalPrice >= this.threshold) return;

    // If gift exists but threshold is now below, remove it
    if (giftExists && totalPrice < this.threshold) {
      await this.removeProduct(giftLineIndex + 1);
      return;
    }

    // If gift does not exist and threshold is met, add it
    console.log(!giftExists, totalPrice,this.threshold)
    if (!giftExists && totalPrice >= this.threshold) {
      await this.addProduct();
    }
  }

  async init() {
    try {
      const cart = await this.fetchCart();
      await this.freeGiftUpdate(cart);
    } catch (e) {
      console.error('Free gift logic error:', e);
    }
  }
}

window.freeGiftPromo = new AddFreeProduct();
